import { CnpjValidator } from './cnpj';

export const CpfCnpjValidator = {
    cpfLength: 11,
    cnpjLength: 14,

    buildDigit(arr) {
        const isCpf = arr.length < this.cpfLength;

        const digit =
            arr
                .map((val, idx) => val * ((!isCpf ? idx % 8 : idx) + 2))
                .reduce((total, current) => total + current, 0)
            % this.cpfLength;

        if (digit < 2 && isCpf) {
            return 0;
        }

        return this.cpfLength - digit;
    },

    isValid(value) {
        if (!value) return true;

        const cpfCnpj = value.replace(/[^a-zA-Z0-9]/g, '');

        // Valores vazios ou incompletos são permitidos (validação obrigatória já cuida disso)
        if (cpfCnpj.length === 0) return true;

        // Se não tem tamanho completo nem de CPF nem de CNPJ, ainda está em progresso
        if (cpfCnpj.length !== this.cpfLength && cpfCnpj.length !== this.cnpjLength) {
            return true;
        }

        // Todos os caracteres iguais
        if (/^(.)\1+$/.test(cpfCnpj)) return false;

        // CNPJ completo — valida dígitos verificadores
        if (cpfCnpj.length === this.cnpjLength) {
            return CnpjValidator(cpfCnpj);
        }

        // CPF completo — valida dígitos verificadores
        const arr = cpfCnpj.split('').reverse().slice(2).map(Number);
        arr.unshift(this.buildDigit(arr));
        arr.unshift(this.buildDigit(arr));

        return cpfCnpj === arr.reverse().join('');
    }
};
